let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0JI3")).then(() => parcelRequire('8mSGu'));